import { createNode, PlainTimeDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromPlainTime } from '../../utils/temporal';

export const ParseTime = createNode({
    id: 'Parse Time',
    name: 'Parse Time',
    description: 'Parses a Time from an ISO 8601 string (e.g. "14:30:00")',
    aiDescription: 'Takes an ISO 8601 time string (e.g. "14:30:00") on the "Text" port and outputs a parsed Time on the "Time" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Text: { kind: 'string' },
    },
    outPorts: {
        Time: PlainTimeDataType,
    },
    execute: function (input) {
        const time = Temporal.PlainTime.from(input.inPorts.Text);
        return { output: { Time: fromPlainTime(time) } };
    },
});
